import  { useState, useContext } from 'react';
import axios from 'axios';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from './Univ.js'

function PatLogin(props) {
    const [formError, setFormError] = useState(false);

    const [errorMsg, seterrorMsg] = useState('');
    const [loginData, setloginData] = useState({
        "username":'',
        "password":'',
    });

    const inputHandler = (event) => {
        setloginData({
            ...loginData,
            [event.target.name]:event.target.value
        })
    };
    const submitForm = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('username', loginData.username);
        formData.append('password', loginData.password);

        axios.post(baseUrl + 'pat-login/', formData)
        .then(function (response) {
            if (response.data.bool === false) {
                setFormError(true);
                seterrorMsg(response.data.msg);
            } else {
                localStorage.setItem('pat_login', true);
                localStorage.setItem('pat_id', response.data.patient_id);
                localStorage.setItem('group', response.data.group);
                setFormError(false);
                seterrorMsg('');
                window.location.href=(response.data.redirect);
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    };


    const buttonEnable = (loginData.username!=='') && (loginData.password!=='')

  return (
  <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header'>Patient Login</h4>
                    <div className='card-body'>
                           {formError &&
                            <p className="text-danger">{errorMsg}</p>
                            }
                        <form onSubmit={submitForm}>
                           <div className="mb-3">
                            <label htmlFor="Username" className="form-label">Username</label>
                            <input type="text" placeholder="Patient ID" className="form-control"
                               name="username" value={loginData.username} onChange={inputHandler} />
                            </div>
                            <div className="mb-3">
                              <label htmlFor="Password" className="form-label">Password</label>
                              <input type="password" className="form-control" placeholder="Password"
                               name="password" value={loginData.password} onChange={inputHandler} />
                            </div>
                          <button type="submit" disabled={!buttonEnable}
                        className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default PatLogin;
